// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'
import type {SetCitiesPayload} from '../actions/setCities'

export function setCitiesReducer(state: MapState, action: Action<SetCitiesPayload>): MapState {

  return {
    ...state,
    cities: action.payload.cities,
  }
}
